// 小屏-地图
<template>
  <div class="DkbSMap">
    <!-- <img src="/static/images/dkb/map/map.png" alt=""> -->
  </div>
</template>

<script>
  import { localUserInfo, showToast } from "../../../../static/js/utility/utility.js"
  let vm

  export default {
    name: 'DkbSMap',
    components: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
   
    },
    mounted() {
      // console.log('route', this.$route)
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbSMap {
  img {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/SScreen/Map.vue